import ApiService from "./api.service";

// const prepareFormSearch = function (form) {
//   let query = {}
//   return query
// }

export const Company = {
  getCompanies: async function() {
    let response = await ApiService.get(`/companies`);
    return response.data.companies;
  },
  create: async function (data) {
    let response = await ApiService.post("/companies", data);
    return response.data;
  },
  update: async function (company_id, data) {
    let response = await ApiService.put("/companies/" + company_id, data);
    return response.data;
  },
  delete: async function (company_id) {
    let response = await ApiService.delete("/companies/" + company_id);
    return response;
  },
  setMain: async function (company_id) {
    let response = await ApiService.patch("/companies/" + company_id + "/main-company");
    return response;
  },
}

export default Company;
